module.exports = __webpack_public_path__ + "static/media/video.905e043b.svg";